/**
 * Shared chrome for the transcript's disclosure blocks (`ThinkingBlock`,
 * `ToolCallsBlock`): wrapper, caret-and-label header, live shimmer. Bodies
 * stay local — prose and a row list want different boxes.
 */
import styled, { css, keyframes } from 'styled-components';

const shimmer = keyframes`
  0%, 100% { opacity: 0.45; }
  50% { opacity: 1; }
`;

export const DisclosureWrap = styled.div`
  position: relative;
  width: 100%;
  /* Sits closer to the answer it belongs to than to the previous turn: the
     block and the reply it explains are one unit. */
  margin-bottom: 6px;
`;

export const DisclosureHeader = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  /* Reset the host page's button chrome — the package renders into pages
     whose globals style bare <button> (see MarkdownContent's colour note). */
  appearance: none;
  border: 0;
  background: none;
  padding: 0;
  margin: 0;
  font: inherit;
  font-size: 0.8125rem;
  cursor: pointer;
  color: var(--text-secondary);

  &:hover {
    color: var(--text-primary);
  }
`;

export const DisclosureCaret = styled.span<{ $open: boolean }>`
  display: inline-block;
  font-size: 0.625rem;
  line-height: 1;
  transition: transform 120ms ease;
  transform: rotate(${({ $open }) => ($open ? '90deg' : '0deg')});
`;

export const DisclosureLabel = styled.span<{ $live: boolean }>`
  ${({ $live }) =>
    $live &&
    css`
      animation: ${shimmer} 1.6s ease-in-out infinite;
    `}

  /* The repo's convention for every looping animation (see ChatView's
     AttachmentProcessing) — an infinite pulse is exactly what a
     reduced-motion setting is asking not to see. */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: ${({ $live }) => ($live ? 0.7 : 1)};
  }
`;
